import { memo } from 'react';
import { useSelector } from 'react-redux';
import { isMobile } from 'utils/is-mobile';
import { EmptyOdd } from 'components/Odds/EmptyOdd';
import { getColCount } from 'store/selectors/app-data';

type Props = {
  size?: 'default' | 'large';
  isExpanded?: boolean;
  sportName?: string;
  colorVariables?: Record<string, string>;
};

const ODDS_GROUP_COUNTS = {
  two: 2,
  three: 3
};

export const EmptyOddGroup = memo(
  ({ size, sportName, isExpanded, colorVariables }: Props) => {
    const colCount =
      useSelector(getColCount) ||
      (!isExpanded && isMobile() && sportName?.toLocaleLowerCase() !== 'soccer'
        ? ODDS_GROUP_COUNTS.two
        : ODDS_GROUP_COUNTS.three);

    if (!colCount) {
      return null;
    }

    return (
      <>
        {new Array(colCount).fill('').map((_, id) => (
          <EmptyOdd colorVariables={colorVariables} key={id} size={size} />
        ))}
      </>
    );
  }
);
